var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_vm._t("default",null,{"errors":_vm.errors && !_vm.errors.messages.length ? _vm.errors.fields : {}}),(_vm.errors && _vm.errors.messages)?_c('div',{class:_vm.$style.errors},_vm._l((_vm.errors.messages),function(msg){return _c('p',{staticStyle:{"margin":"0px"}},[_vm._v(_vm._s(msg))])}),0):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }